<script setup lang="ts">
const solutions = [
  'Riwayat pengiriman dapat diunduh dengan mudah dalam format Excel atau CSV.',
  'Ketahui tren pengiriman berdasarkan jumlah paket dan area tujuan dengan statistik area pengiriman.',
  'Pantau status paket di setiap tahapan pengiriman dengan ringkasan yang mudah dipahami.'
]
</script>

<template>
  <div class="flex flex-col gap-11 py-4 lg:py-16">
    <UiSectionWrapper
      image-class="lg:order-first"
      title="Data Pengiriman Lengkap untuk Bisnismu"
      description="Nikmati kemudahan mengelola pengiriman bisnismu dengan laporan lengkap dan visualisasi data."
      hero-image="/images/batch-2/report-add-1.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
          <div
            v-for="(solution, index) in solutions"
            :key="index"
            class="flex gap-2"
          >
            <Icon
              class="text-primary flex-none"
              name="material-symbols:verified"
              size="24px"
            />
            <p class="text-sm lg:text-lg flex-1">
              {{ solution }}
            </p>
          </div>
        </div>
      </template>
    </UiSectionWrapper>
  </div>
</template>
